let nextId = 1;

// setupObserver :: Node -> Params -> Effect (Effect Unit)
export const setupObserver = (node) => (params) => () => {
  const id = nextId++;

  let observer = null;
  const unsubscribe = () => {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  };

  setTimeout(() => {
    let root = undefined;
    if (params.rootSelector) {
      root = node.closest(params.rootSelector);
      if (!root) {
        throw new Error(
          `Root element with selector ${params.rootSelector} not found`
        );
      }
    }

    let lastEntry, timeoutId;

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          console.log(
            `IntersectionObserver ${id} triggered, isIntersecting=${entry.isIntersecting}`
          );

          if (timeoutId) {
            clearTimeout(timeoutId);
          }

          lastEntry = entry;
          timeoutId = setTimeout(() => {
            if (lastEntry.isIntersecting) {
              console.log(`IntersectionObserver ${id} notifying`);
              params.onVisible();
              unsubscribe();
            } else {
              console.log(`IntersectionObserver ${id} suppressed`);
            }
          }, params.debounceTimeMs);
        }
      },
      {
        threshold: params.threshold,
        root,
      }
    );
    observer.observe(node);
  }, 0);
  return unsubscribe;
};
